import { TravelRulePersonType } from '@shared/graphql'

import type {
  TravelRulePerson,
  TravelRuleNaturalPerson,
  TravelRuleLegalPerson,
  Maybe,
} from '@shared/graphql'

/**
 * Type guard to check if natural person.
 */
export function isNaturalPerson(
  person?: Maybe<TravelRulePerson>,
): person is TravelRuleNaturalPerson {
  return person?.type === TravelRulePersonType.NATURAL
}

/**
 * Type guard to check if a legal person.
 */
export function isLegalPerson(
  person?: Maybe<TravelRulePerson>,
): person is TravelRuleLegalPerson {
  return person?.type === TravelRulePersonType.LEGAL
}
